import { render, staticRenderFns } from "./PaymentTransactionCard.vue?vue&type=template&id=a5f63ab6&scoped=true"
import script from "./PaymentTransactionCard.vue?vue&type=script&lang=js"
export * from "./PaymentTransactionCard.vue?vue&type=script&lang=js"
import style0 from "./PaymentTransactionCard.vue?vue&type=style&index=0&id=a5f63ab6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f63ab6",
  null
  
)

export default component.exports